import { useLang } from '../../../../../../hooks/use-lang';
import { useToggle } from '../../../../../../hooks/use-toggle';
import { useCompanyStore } from '../../../../../../store/use-company-store';

export const useCompanySocials = () => {
  const {
    handleUpdateCompanyProfile,
    companyProfile,
    isLoading,
    handleResetCompanyProfile,
    handleSaveCompanyProfile,
  } = useCompanyStore();
  const socials = companyProfile?.socials?.filter((item) => item.default !== undefined) || [];
  
  const { t } = useLang();

  const handleAdd = () => {
    handleUpdateCompanyProfile({ socials: [...socials, { type: '', url: '' }] });
  };

  const handleDelete = (index: number) => {
    handleUpdateCompanyProfile({ socials: socials.filter((_, i) => i !== index) });
  };

  const handleSetUrl = (index: number, value: string) => {
    handleUpdateCompanyProfile({
      socials: socials.map((el, i) => (i === index ? { ...el, url: value } : el)),
    });
  };

  const [disabled, toggleDisabled, setDisabled] = useToggle(true);

  const handleCancel = () => {
    handleResetCompanyProfile();
    setDisabled(true);
  };

  const handleSave = () => {
    handleSaveCompanyProfile().then(() => setDisabled(true));
  };

  return {
    t,
    socials,
    handleAdd,
    handleDelete,
    handleSetUrl,
    disabled,
    toggleDisabled,
    isLoading,
    handleCancel,
    handleSave,
  };
};
